import { PutawayTaskDetailPage } from "@/features/putaway-task/pages/PutawayTaskDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/putaway-task/$id/detail")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["putaway_task.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PutawayTaskDetailPage,
});
